/**
 * Appels API pour les tags.
 */

import api from "./axiosConfig";

/**
 * Récupère la liste de tous les tags.
 * @returns {Promise<Array>} Liste des tags.
 */
export async function getTags() {
  const response = await api.get("/tags");
  return response.data;
}

/**
 * Crée un nouveau tag.
 * @param {string} label - Libellé du tag.
 * @returns {Promise<Object>} Le tag créé.
 */
export async function createTag(label) {
  const response = await api.post("/tags", { label });
  return response.data;
}
